import {
  CSSProperties,
  ReactNode
} from 'react';

interface SectionLayoutProps {
  children: ReactNode
  className?: string
  style?: CSSProperties
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '7xl'
  label?: string
  heading?: string
  description?: string
}

export function SectionHeader({
  label,
  heading,
  description,
  centered = true
}: {
  label?: string
  heading: string
  description?: string
  centered?: boolean
}) {

  return (
    <div className={`mb-14 ${ centered ? 'text-center' : '' }`}>
      {label && (
        <p className="text-sm font-semibold uppercase tracking-widest text-[#c8861c] mb-3">
          {label}
        </p>
      )}
      <h2 className="text-3xl sm:text-[32px] font-light text-[#111111] dark:text-white leading-snug max-w-3xl mx-auto">
        {heading}
      </h2>
      {/* whitespace-pre-line so a description written in paragraphs survives.
          Most callers pass a single-line string literal, for which this is a
          visual no-op - it only does anything when the text actually contains
          newlines. That matters for the descriptions that come from the
          DATABASE rather than from source: a donation campaign's appeal is
          written in a textarea and was being flattened into one dense
          paragraph, which is the copy doing the persuading.
          All 56 callers were checked; none passes a multi-line template
          literal, so nothing existing changes. */}
      {description && (
        <p className="mt-4 text-base font-normal text-[#111111] dark:text-white leading-relaxed max-w-2xl mx-auto whitespace-pre-line">
          {description}
        </p>
      )}
    </div>
  );
}

export default function SectionLayout({
  children,
  className = 'bg-white dark:bg-gray-900',
  style,
  maxWidth = '4xl',
  label,
  heading,
  description
}: SectionLayoutProps) {

  return (
    <section className={`py-20 px-6 sm:px-8 ${ className }`} style={style}>
      <div className={`max-w-${ maxWidth } mx-auto`}>
        {heading && (
          <SectionHeader label={label} heading={heading} description={description} />
        )}
        {children}
      </div>
    </section>
  );
}
